/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import CampaignModel, { AudienceSettingsType } from 'cio/models/campaign';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';
import { action, computed } from '@ember/object';
import SubscriptionCenterService from 'cio/services/subscription-center';
import DS from 'ember-data';
import { getAudienceSummaryText } from 'cio/utils/campaigns/sumaries';

interface CampaignOverviewPageDetailsCardArgs {
  campaign: CampaignModel;
}

export default class CampaignOverviewPageDetailsCard extends Component<CampaignOverviewPageDetailsCardArgs> {
  @service analytics!: AnalyticsService;
  @service store!: DS.Store;
  @service subscriptionCenter!: SubscriptionCenterService;

  @action
  onCopy() {
    this.analytics.track('campaign', 'webhook_url_copied', {
      model: this.args.campaign,
      source: 'Overview Tab',
    });
  }

  @computed('args.campaign.conversionAction')
  get campaignConversionActionInPastTense(): string {
    let { conversionAction } = this.args.campaign;

    // eslint-disable-next-line spellcheck/spell-checker
    if (conversionAction.slice(-3) === 'ing') {
      return `${conversionAction.slice(0, -3)}ed`;
    }

    return conversionAction;
  }

  get audienceSummary() {
    return getAudienceSummaryText(this.args.campaign, this.args.campaign.objectTypeForCampaign, true);
  }

  get showAudienceConditions() {
    return this.args.campaign.audience?.type === AudienceSettingsType.filtered;
  }
}
